// extracted by mini-css-extract-plugin
export default {"tooltip":"hit_commentaries_list_see_more-module__tooltip--1HM7r"};